import { render, staticRenderFns } from "./RejectionAction.vue?vue&type=template&id=f4d3367c&scoped=true&"
import script from "./RejectionAction.vue?vue&type=script&lang=js&"
export * from "./RejectionAction.vue?vue&type=script&lang=js&"
import style0 from "./RejectionAction.vue?vue&type=style&index=0&id=f4d3367c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3367c",
  null
  
)

export default component.exports